export default (state, action) => {
  return {
    ...state,
    socialPage: action.option,
    dataForSocialPagesSelect: {
      ...state.dataForSocialPagesSelect,
      value: action.option
    },
  };
}